module.exports = __webpack_public_path__ + "img/010-smileys.0313a8c5.png";